<template>
  <date-range-picker
    v-model="dateRange"
    :locale-data="{ format: 'mm-dd-yyyy HH:MM', separator: ' - ' }"
    :append-to-body="true"
    :ranges="false"
    :min-date="minDate"
    :time-picker="true"
    :time-picker24-hour="false"
    :opens="opens"
    :time-picker-labels="labels"
    :captions-of-date="captionsOfDate"
    @toggle="onToggle"
    @select="validateRange"
    @update="onUpdate"
  >
    <template v-slot:input="">
      <fg-input
        :value="range"
        :readonly="true"
        addon-left-icon="bx bx-calendar"
        placeholder="Select date"
      />
    </template>
    <div slot="footer" slot-scope="data" class="slot">
      <div class="container-fluid">
        <div v-if="validMsg !== ''" class="date-range-error">
          {{ validMsg }}
        </div>
        <div class="row align-items-center">
          <div class="col-sm-12 text-right">
            <n-button
              type="danger"
              size="sm"
              class="mr-1"
              @click.native="data.clickCancel"
            >
              Cancel
            </n-button>
            <n-button
              :disabled="data.in_selection || validMsg !== ''"
              type="success"
              size="sm"
              @click.native="data.clickApply"
            >
              Apply
            </n-button>
          </div>
        </div>
      </div>
    </div>
  </date-range-picker>
</template>

<script>
import DateRangePicker from "apc-daterange-picker";
import "apc-daterange-picker/dist/apc-daterange-picker.css";
import moment from "moment";
import { Button, Card, FormGroupInput } from "@/components";

export default {
  components: {
    DateRangePicker,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  props: {
    initialRange: {
      type: Object,
      default() {
        return {
          startDate: moment().add(1, "hours").startOf("hour").toDate(),
          endDate: moment().add(75, "hours").startOf("hour").toDate(),
        };
      },
    },
    maxLength: {
      type: Number,
      default: 30,
    },
    captionsOfDate: {
      type: [],
      default: null,
    },
  },
  data() {
    return {
      dateRange: {
        startDate: moment().add(1, "hours").startOf("hour").toDate(),
        endDate: moment().add(75, "hours").startOf("hour").toDate(),
      },
      minDate: moment().subtract(1, "days").toDate(),
      validMsg: "",
      opens: "right",
      labels: ["Check In Time", "Check Out Time"],
    };
  },
  computed: {
    range() {
      return this.dateRange.startDate && this.dateRange.endDate
        ? moment(this.dateRange.startDate).format("MM/DD/YYYY hh:mm A") +
            " - " +
            moment(this.dateRange.endDate).format("MM/DD/YYYY hh:mm A")
        : "";
    },
  },
  created() {
    this.$emit("update", this.initialRange);
    this.dateRange = this.initialRange;

    if (window.innerWidth < 768) {
      this.opens = "center";
    } else {
      this.opens = "right";
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 768) {
        this.opens = "center";
      } else {
        this.opens = "right";
      }
    });
  },
  methods: {
    validateRange({ startDate, endDate }) {
      console.log("startDate: ", startDate);
      console.log("endDate: ", endDate);
      const diff = moment(endDate).diff(moment(startDate), "hours");
      if (diff < 0) {
        this.validMsg = "Start date must be less than end date";
      } else if (diff > this.maxLength * 24) {
        this.validMsg = `Your date range exceeded the maximum length of ${this.maxLength} days.`;
      } else {
        this.validMsg = "";
      }
    },
    onUpdate(date) {
      this.$emit("update", date);
    },
    onToggle(open) {
      if (!open) {
        this.validMsg = "";
      } else {
        this.$emit("scrollUp");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .form-control {
    padding-left: 12px !important;
    padding-right: 8px !important;
  }
}
.date-range-error {
  color: #ff3636 !important;
  text-align: center;
}
</style>
